"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditAction = exports.AuditCategory = void 0;
var AuditCategory;
(function (AuditCategory) {
    AuditCategory["DATA_ENTRY"] = "data_entry";
    AuditCategory["DATA_MANAGEMENT"] = "data_management";
    AuditCategory["RATES"] = "rates";
    AuditCategory["USERS"] = "users";
    AuditCategory["FINANCIALS"] = "financials";
})(AuditCategory = exports.AuditCategory || (exports.AuditCategory = {}));
var AuditAction;
(function (AuditAction) {
    AuditAction["CREATED"] = "created";
    AuditAction["UPDATED"] = "updated";
    AuditAction["DELETED"] = "deleted";
    AuditAction["LOCKED_TRUCK"] = "locked_truck";
    AuditAction["APPROVED"] = "approved";
    AuditAction["PLACED_ON_HOLD"] = "placed_on_hold";
    AuditAction["ADJUSTED_PAYROLL_TRUCKS"] = "adjusted_payroll_trucks";
    AuditAction["ADDED_SUPPLEMENTAL_PAYROLL_DATA"] = "added_supplemental_payroll_data";
    AuditAction["GENERATED_PAYROLL"] = "generated_payroll";
    AuditAction["FINALIZED_PAYROLL"] = "finalized_payroll";
    AuditAction["FINALIZED_SPECIAL_PAYROLL"] = "finalized_special_payroll";
})(AuditAction = exports.AuditAction || (exports.AuditAction = {}));
//# sourceMappingURL=audits.js.map